import { render } from "./CalculatorIcon.vue?vue&type=template&id=b36fbef8"
import script from "./CalculatorIcon.vue?vue&type=script&lang=js"
export * from "./CalculatorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__